export function getAgreements({ jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/getAgreementRecord`, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: `Bearer ${jwt}` },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}

export function putAgreements({ jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/putAgreementRecord`, {
    method: "PUT",
    headers: { Authorization: `Bearer ${jwt}` },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}
